/* eslint-disable @next/next/no-img-element */
import React from 'react'
import styled from '@emotion/styled'
import { gsColors } from '../../../../styles/Variables'
import { useAllMarketServices } from '../../../../services/GraphQlClientService'
import { mq, serviceAndAddOnServiceNames } from '../../../../helpers'

const SelectedServicesDiv = styled.div`
  width: 100%;

  .services {
    line-height: 24px;
    max-height: 170px;
    overflow: auto;
    background-color: #fff;
    width: 100%;

    li {
      border-top: 1px solid ${gsColors.ebb};
      position: relative;
      width: 100%;
      padding: 20px 32px 20px 52px;

      &:first-of-type {
        border-top: none;
      }

      .service-name-container {
        // pointer-events: none;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .remove {
          all: unset;
          cursor: pointer;

          &:hover {
            cursor: pointer;
          }

          img {
            pointer-events: none;
          }
        }
      }

      .add-on-list {
        pointer-events: none;
        display: flex;
        flex-direction: column;
        padding-left: 20px;

        span {
          color: ${gsColors.meredithGrey};
          font-family: Euclid;
          font-size: 16px;
          font-weight: 500;
          line-height: 100%;
          letter-spacing: 1.2px;
          text-transform: capitalize;
        }
      }
    }

    span {
      display: block;
    }

    .service-name {
      pointer-events: none;
      font-family: Euclid;
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 1.2px;
      text-transform: capitalize;

      ${mq('min', '768px')} {
        font-size: 16px;
      }
    }

    .add-ons {
      color: ${gsColors.venus};
      font-size: 12px;

      ${mq('min', '768px')} {
        font-size: 14px;
      }
    }
  }

  .add-service {
    border: none;
    background-color: #fff;
    width: 100%;
    border-top: 1px solid ${gsColors.lightTangerine};
    color: ${gsColors.sunsetOrange};
    text-align: left;
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    padding: 20px 32px 20px 52px;
    font-size: 16px;
  }
`

const SelectedServices = ({
  step,
  services,
  deselectMarketService,
  goToStep2,
  market = null
}) => {
  const allMarketServices = useAllMarketServices()

  const SelectedServiceInfo = (serviceRequest) => {
    const { serviceName, addOnServiceNames } = serviceAndAddOnServiceNames(
      allMarketServices,
      serviceRequest,
      market?.id
    )

    if (!serviceName) {
      return null
    }
    const Trashcan = () => {
      if (services.length <= 1 && step === 3) {
        return null
      }
      return (
        <button
          className="remove"
          id="cart-remove"
          onClick={() => deselectMarketService(serviceRequest.serviceId)}
        >
          <img src="/images/cart-close-icon.svg" alt="remove service" />
        </button>
      )
    }
    return (
      <li key={serviceRequest.serviceId}>
        <div className="service-name-container">
          <span className="service-name">
            {serviceRequest.instances} {serviceName.toLowerCase()}
          </span>
          <Trashcan />
        </div>
        <div className="add-on-list">
          {addOnServiceNames.map((addOnName, i) => (
            <span key={i}>+ {addOnName}</span>
          ))}
        </div>
        <span className="add-ons"></span>
      </li>
    )
  }

  return (
    <SelectedServicesDiv>
      <ul
        className={`services ${services.length > 2 ? 'scroll' : ''}`}
        id="cart-list"
      >
        {services.map(SelectedServiceInfo)}
      </ul>
      <button onClick={goToStep2} className="add-service">
        + Add Service
      </button>
    </SelectedServicesDiv>
  )
}
export default SelectedServices
